export default "__VITE_ASSET__5ccc27ae__"